var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShareDesktop = function SvgShareDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.875h10c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-1.875a.625.625 0 1 1 0 1.25h-6.25a.625.625 0 1 1 0-1.25H2.5c-.69 0-1.25-.56-1.25-1.25v-7.5c0-.69.56-1.25 1.25-1.25Zm0 1.25v7.5h10v-7.5h-10Zm5.625 2.5c-2.557 0-3.75 1.094-3.75 4.375 1.364-2.656 3.75-2.5 3.75-2.5v.536a.5.5 0 0 0 .814.39l1.828-1.474a.5.5 0 0 0 0-.779L8.939 4.7a.5.5 0 0 0-.814.389v.536Z",
    fill: "#fff"
  })));
};

export default SvgShareDesktop;